import { render, staticRenderFns } from "./RelativesAdd.vue?vue&type=template&id=08c74887&scoped=true&"
import script from "./RelativesAdd.vue?vue&type=script&lang=js&"
export * from "./RelativesAdd.vue?vue&type=script&lang=js&"
import style0 from "./RelativesAdd.vue?vue&type=style&index=0&id=08c74887&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c74887",
  null
  
)

export default component.exports